import styled from '@emotion/styled';
interface InputTextProps {
	readonly isError?: boolean;
}
export const Container = styled.div`
	position: relative;
	width: 100%;
`;

export const ContainerInput = styled.input<InputTextProps>`
	height: 4.4rem;
	padding: ${(props) => (props.isError ? '0 3.6rem 0 1.2rem' : '0.8rem 1.2rem')};
	border: 1px solid #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #212121;
	width: 100%;
	&:focus {
		outline: none;
		border: 2px solid ${(props) => props.theme.colors.primary400};
		border-radius: 0;
	}
	&::placeholder {
		color: #adb5bd;
	}
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;

export const IconWrapper = styled.div`
	position: absolute;
	right: 1.2rem;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none; /* 클릭 방지 */
`;
